import React from 'react';
import SideBar from '../../../shared/templates/CategoryTemplate/category-sidebar';

function TravelSideBar(props) {
  return (<SideBar {...props} 
    section="travel"
    searchTitle="Search Travel"
    createNewTitle="New Travel"
    filterList={[
      { name:'keywords', value: 'Enter Keywords' }, 
    ]}
  />);
}

export default TravelSideBar;